import { useChangePassword } from '@/hooks';
import React from 'react';

interface ChangePasswordFormProps {
  onSuccess?: () => void;
}

export const ChangePasswordForm: React.FC<ChangePasswordFormProps> = ({ onSuccess }) => {
  const {
    oldPassword,
    newPassword,
    confirmPassword,
    displayError,
    isSubmitting,
    setOldPassword,
    setNewPassword,
    setConfirmPassword,
    handleSubmit,
  } = useChangePassword({ onSuccess });

  return (
    <form onSubmit={handleSubmit}>
      {displayError && (
        <div className="alert alert-danger" role="alert">
          <i className="fas fa-exclamation-circle me-2"></i>
          {displayError}
        </div>
      )}

      <div className="mb-3">
        <label htmlFor="oldPassword" className="form-label">
          Current Password
        </label>
        <input
          type="password"
          className="form-control"
          id="oldPassword"
          value={oldPassword}
          onChange={(event) => setOldPassword(event.target.value)}
          disabled={isSubmitting}
          autoComplete="current-password"
          placeholder="Enter your current password"
          required
        />
      </div>

      <div className="mb-3">
        <label htmlFor="newPassword" className="form-label">
          New Password
        </label>
        <input
          type="password"
          className="form-control"
          id="newPassword"
          value={newPassword}
          onChange={(event) => setNewPassword(event.target.value)}
          disabled={isSubmitting}
          autoComplete="new-password"
          placeholder="Enter a new password"
          required
        />
      </div>

      <div className="mb-4">
        <label htmlFor="confirmPassword" className="form-label">
          Confirm New Password
        </label>
        <input
          type="password"
          className="form-control"
          id="confirmPassword"
          value={confirmPassword}
          onChange={(event) => setConfirmPassword(event.target.value)}
          disabled={isSubmitting}
          autoComplete="new-password"
          placeholder="Re-enter your new password"
          required
        />
      </div>

      <button type="submit" className="btn btn-primary w-100" disabled={isSubmitting}>
        {isSubmitting ? (
          <>
            <span
              className="spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
            ></span>
            Updating password...
          </>
        ) : (
          <>
            <i className="fas fa-key me-2"></i>
            Change Password
          </>
        )}
      </button>
    </form>
  );
};

export default ChangePasswordForm;
